 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		13: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		13: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"ceead369a3248773bb321ef9c26082375f134405","2":"74d990c4376e992f9ed6174c7a9b1e9c58163374","3":"a9a7754c","4":"cb1608f2","5":"fcff3c4af1676db64012fb10ff209ff56d3a06d2","6":"8d5b4a30445d2b887f5249c99b84e7cc3d3f556d","7":"4d37f247348525f4db8943ca843fb543965220c5","8":"5eb7aae0ec5170cb203ac6f593c319eaaafad365","9":"40c750d591b56d02694cd7bdbc7aa866bb9136fa","10":"382a42ad","11":"382fc01dd067accbf268db4de14abc6d7a39d2af","12":"bbd60a5f5027ce7da1804f967d3f66d6d5d807f0","17":"component---src-components-slides-blueprints-blueprint-blueprint-jsx","18":"component---src-components-slides-checkout-checkout-jsx","19":"component---src-components-slides-integrations-integration-integration-jsx","20":"component---src-components-slides-landing-pages-landing-page-landing-page-jsx","21":"component---src-components-slides-landing-pages-optin-page-optin-page-jsx","22":"component---src-components-slides-learn-page-page-jsx","23":"component---src-components-slides-partners-partner-partner-jsx","24":"component---src-pages-404-js","25":"component---src-pages-affiliate-terms-js","26":"component---src-pages-blueprints-js","27":"component---src-pages-case-studies-js","28":"component---src-pages-cookies-js","29":"component---src-pages-dpa-js","30":"component---src-pages-features-campaigns-js","31":"component---src-pages-features-js","32":"component---src-pages-features-people-js","33":"component---src-pages-features-personalization-js","34":"component---src-pages-features-portal-js","35":"component---src-pages-features-reporting-js","36":"component---src-pages-gdpr-js","37":"component---src-pages-index-js","38":"component---src-pages-integrations-js","39":"component---src-pages-learn-js","40":"component---src-pages-o-stealth-selling-4-js","41":"component---src-pages-o-stealth-selling-7-js","42":"component---src-pages-o-stealth-selling-js","43":"component---src-pages-old-case-studies-js","44":"component---src-pages-payment-update-js","45":"component---src-pages-podcasts-js","46":"component---src-pages-portal-launch-js","47":"component---src-pages-pricing-js","48":"component---src-pages-security-js","49":"component---src-pages-signup-25-off-special-js","50":"component---src-pages-signup-50-off-special-js","51":"component---src-pages-signup-details-js","52":"component---src-pages-signup-index-js","53":"component---src-pages-signup-portal-js","54":"component---src-pages-start-js","55":"component---src-pages-stealth-selling-js","56":"component---src-pages-subprocessors-js","57":"component---src-pages-success-js","58":"component---src-pages-thank-you-js","59":"component---src-pages-tos-js","60":"component---src-pages-upsell-stealth-selling-js","61":"component---src-pages-welcome-js"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"3a19e9021bd5275a5b1a","2":"b64b1b1fe57d002002f5","3":"810d494a1d971fa4146b","4":"cf39d4ba041ca6dd4ca8","5":"3e9b51f6d06945689b84","6":"7c4cdfe8747432dae400","7":"c07945187ad126829596","8":"ebd7f4f9cea03f819574","9":"4fafcac547a5f9ca4c6a","10":"67c3ef4298284a4f9d16","11":"244dcc1cf0812627d658","12":"87c3edc7843fcf8533dc","17":"c71ad017b534dc5eb7c1","18":"3e7acc8d5cbed04dc4a7","19":"9a28282a21d83e35fe54","20":"736da906691bbb0db2d6","21":"f78ed7efa1381da2293d","22":"3f17dcb3e024cd521e6a","23":"435bad717610c043bc97","24":"7ff09ee65b516fffed65","25":"e8885aadeea58c4ca2a9","26":"a17eb5f14a5f2bc34fb5","27":"e4f6e7831ba30c389937","28":"d7dbdc73c005d18fcb7e","29":"20877a4997b1d7b41f9c","30":"5d2699a2bea1a5a20532","31":"0e32e0e6aca34cda4b25","32":"fc36f7a8463709f15baa","33":"87aa41c0d0c2857df9ab","34":"474a0b172f8adfacafe5","35":"e44b8180214493344b48","36":"9b3b26e359530be67c2b","37":"7840853ea28d2ff8351a","38":"b986c3234c19b43109ac","39":"ff2783c2118e5c5a46d2","40":"58a8b50cc88acd7c32c3","41":"016d89e26eb6f53343d7","42":"98cf93d28606614cc89e","43":"bdd6250d13ed8fa240a2","44":"e40458fc8ab016a41b23","45":"6a25abedafa13d8afb93","46":"e2a978f57591a23e559a","47":"077bcb72c58571830bf6","48":"348fa334829d3f6a19a0","49":"d79801042ceabc203e71","50":"71e16f48b3480ea5c6ca","51":"790e5107e2e9c6b7f65b","52":"16d7755baef4e86220cf","53":"6126c7e7ab34cb03e1cf","54":"b0bced0a4b9c8afc92f0","55":"3fb9952efe42b911d4c3","56":"e935b604820c6996eea7","57":"86e30e39d1713ca00455","58":"cbe3b098eab5de199ee5","59":"a54fcc1639029b5708b2","60":"51acf54126e3f3f87cde","61":"26bca528f0b725d50a0c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"ceead369a3248773bb321ef9c26082375f134405","2":"74d990c4376e992f9ed6174c7a9b1e9c58163374","3":"a9a7754c","4":"cb1608f2","5":"fcff3c4af1676db64012fb10ff209ff56d3a06d2","6":"8d5b4a30445d2b887f5249c99b84e7cc3d3f556d","7":"4d37f247348525f4db8943ca843fb543965220c5","8":"5eb7aae0ec5170cb203ac6f593c319eaaafad365","9":"40c750d591b56d02694cd7bdbc7aa866bb9136fa","10":"382a42ad","11":"382fc01dd067accbf268db4de14abc6d7a39d2af","12":"bbd60a5f5027ce7da1804f967d3f66d6d5d807f0","17":"component---src-components-slides-blueprints-blueprint-blueprint-jsx","18":"component---src-components-slides-checkout-checkout-jsx","19":"component---src-components-slides-integrations-integration-integration-jsx","20":"component---src-components-slides-landing-pages-landing-page-landing-page-jsx","21":"component---src-components-slides-landing-pages-optin-page-optin-page-jsx","22":"component---src-components-slides-learn-page-page-jsx","23":"component---src-components-slides-partners-partner-partner-jsx","24":"component---src-pages-404-js","25":"component---src-pages-affiliate-terms-js","26":"component---src-pages-blueprints-js","27":"component---src-pages-case-studies-js","28":"component---src-pages-cookies-js","29":"component---src-pages-dpa-js","30":"component---src-pages-features-campaigns-js","31":"component---src-pages-features-js","32":"component---src-pages-features-people-js","33":"component---src-pages-features-personalization-js","34":"component---src-pages-features-portal-js","35":"component---src-pages-features-reporting-js","36":"component---src-pages-gdpr-js","37":"component---src-pages-index-js","38":"component---src-pages-integrations-js","39":"component---src-pages-learn-js","40":"component---src-pages-o-stealth-selling-4-js","41":"component---src-pages-o-stealth-selling-7-js","42":"component---src-pages-o-stealth-selling-js","43":"component---src-pages-old-case-studies-js","44":"component---src-pages-payment-update-js","45":"component---src-pages-podcasts-js","46":"component---src-pages-portal-launch-js","47":"component---src-pages-pricing-js","48":"component---src-pages-security-js","49":"component---src-pages-signup-25-off-special-js","50":"component---src-pages-signup-50-off-special-js","51":"component---src-pages-signup-details-js","52":"component---src-pages-signup-index-js","53":"component---src-pages-signup-portal-js","54":"component---src-pages-start-js","55":"component---src-pages-stealth-selling-js","56":"component---src-pages-subprocessors-js","57":"component---src-pages-success-js","58":"component---src-pages-thank-you-js","59":"component---src-pages-tos-js","60":"component---src-pages-upsell-stealth-selling-js","61":"component---src-pages-welcome-js"}[chunkId]||chunkId) + "." + {"0":"ff4295174e50ebcf2eb1","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://www.dfstaging.com/gatsby-static/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
